module.exports = __webpack_public_path__ + "static/media/Satoshi-Medium.7bec8149.ttf";